import { compact, get, isEmpty, orderBy } from 'lodash';
import {
  ComponentTypes,
  IAssemblyComponent,
  IComponentType,
  ILayout,
  ISectionConfig,
} from 'src/interfaces';

export const checkNumOfComponents = (
  layouts: ILayout[],
  assemblyComponents: Partial<IAssemblyComponent>[],
) => {
  for (const layout of layouts) {
    for (const screen of layout.screens) {
      for (const section of screen.sections) {
        const isExisted = assemblyComponents.find(
          (assemblyComponent) =>
            assemblyComponent.layout_screen_id === screen.layoutScreenId &&
            assemblyComponent.screen_section_id === section.screenSectionId,
        );

        if (!isExisted) return false;
      }
    }
  }

  return true;
};

export const findMatchedAssemblyComponents = (
  assemblyComponents: IAssemblyComponent[],
  layoutScreenId?: number,
  screenSectionId?: number,
  sort: string[] = [],
  parentAssemblyComponents: IAssemblyComponent[] = [],
  order: Array<'asc' | 'desc'> = [],
) => {
  const matchedAssemblyComponents = assemblyComponents.filter(
    (item) =>
      item.layout_screen_id === layoutScreenId &&
      item.screen_section_id === screenSectionId,
  );
  const matchedParentAssemblyComponents = parentAssemblyComponents.filter(
    (item) =>
      item.layout_screen_id === layoutScreenId &&
      item.screen_section_id === screenSectionId,
  );

  return orderBy(
    compact(
      isEmpty(matchedAssemblyComponents)
        ? matchedParentAssemblyComponents
        : matchedAssemblyComponents,
    ),
    sort,
    order,
  );
};

export const showParentIcon = (
  assemblyComponents: Partial<IAssemblyComponent>[],
  layoutScreenId?: number,
  screenSectionId?: number,
  parentId?: number,
) => {
  const matchedAssemblyComponents = assemblyComponents.filter(
    (item) =>
      item.layout_screen_id === layoutScreenId &&
      item.screen_section_id === screenSectionId,
  );
  if (parentId !== null && matchedAssemblyComponents.length === 0) {
    return true;
  } else {
    return false;
  }
};

export const showChildIcon = (
  assemblyComponents: Partial<IAssemblyComponent>[],
  layoutScreenId?: number,
  screenSectionId?: number,
  parentId?: number,
) => {
  const matchedAssemblyComponents = assemblyComponents.filter(
    (item) =>
      item.layout_screen_id === layoutScreenId &&
      item.screen_section_id === screenSectionId,
  );
  if (parentId !== null && matchedAssemblyComponents.length > 0) {
    return true;
  } else {
    return false;
  }
};

export const handleFiltersForComponents = (
  currentDate: string,
  layoutTypeId: number,
  componentTypes: IComponentType[] = [],
  replaceComponentID?: number,
  selectedSection?: {
    layoutScreenId: number;
    screenSectionId: number;
    sectionId: number;
    width: number;
    height: number;
    config?: ISectionConfig | undefined;
  },
) => {
  const basicFilters = [
    `end_date.from=${currentDate}`,
    `width=${selectedSection?.width}`,
    `height=${selectedSection?.height}`,
    `layout_type_id=${layoutTypeId}`,
  ];

  if (replaceComponentID) {
    basicFilters.push(`id.notlist=${replaceComponentID}`);
  }

  const suggestedComponentTypes = get(
    selectedSection,
    'config.suggestedComponentTypes',
    [],
  ) as ComponentTypes[];

  const componentTypeIDs = isEmpty(suggestedComponentTypes)
    ? componentTypes
        .filter(
          (item) =>
            item.name !== ComponentTypes.COD &&
            item.name !== ComponentTypes.COD_THANK_YOU,
        )
        .map((item) => item.id)
    : componentTypes
        .filter((item) =>
          suggestedComponentTypes.includes(item.name as ComponentTypes),
        )
        .map((item) => item.id);

  basicFilters.push(`component_type_id.list=${componentTypeIDs.join('|')}`);

  return basicFilters;
};
